import Page from "../Page";
import styles from "./Publishing.module.scss";
import Connections from "./Connections/Connections";

function Publishing() {
  return (
    <Page title="Publishing" documentTitle="Publishing" fullHeight>
      <div className={styles.container}>
        <Connections />
      </div>
    </Page>
  );
}

export default Publishing;
